
import BannersCarousel from "@/components/BannersCarousel.vue";
import LoaderContainer from "@/components/Loader.vue";
import PaginatorComponent from "@/components/Paginator.vue";
import ProdutoDetailsDialog from "@/components/produtos/ProdutoDetailsDialog.vue";
import { Produto } from "@/interfaces/Produto";
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import FiltroProdutosContainer from "./filters/Categoria.filter.vue";
import ProdutoCard from "./ProdutoCard.vue";

const AuthStore = namespace("Auth");

@Component({
  name: "ListaProdutos",
  props: {
    items: {
      type: Promise,
      default: () => Promise.resolve([]),
    },
  },
  components: {
    PaginatorComponent,
    ProdutoCard,
    ProdutoDetailsDialog,
    LoaderContainer,
    BannersCarousel,
    FiltroProdutosContainer,
  },
})
export default class ListaProdutos extends Vue {
  drawerstate = false;
  listaProdutos = [] as Array<any>;
  isLoading = true;
  totalItensServer = 0;

  produtoInfo = {} as Produto;

  @AuthStore.Getter
  private isLoggedIn!: boolean;

  @Watch("items")
  async onItemsChanged(value: Promise<any>) {
    this.isLoading = true;
    this.listaProdutos = await value
      .then((resp: any) => {
        console.log(resp);
        this.totalItensServer = +resp.totalrecordcount;
        return resp.data;
      })
      .catch(() => {
        this.totalItensServer = 0;
        return [] as Array<any>;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  @Watch("isLoading")
  onIsLoadingChanged(value: any) {
    this.isLoading = value;
  }

  get cardDimensions() {
    if (this.$vuetify.breakpoint.width < 380) return "100%";
    if (this.$vuetify.breakpoint.xs) return "180px";

    if (
      this.$vuetify.breakpoint.sm ||
      this.$vuetify.breakpoint.md ||
      this.$vuetify.breakpoint.lg
    ) {
      return "200px";
    }

    return "250px";
  }

  // mounted() {
  //   this.buscarDadosAPI();
  // }

  // @Watch("filtros")
  // onFiltrosChanged() {
  //   this.buscarDadosAPI();
  // }

  // @Watch("ordenacao")
  // onOrdenacaoChanged() {
  //   this.buscarDadosAPI();
  // }

  // @Watch("isLoggedIn")
  // onLoggedInChanged() {
  //   this.buscarDadosAPI();
  // }

  // onPageChanged() {
  //   this.buscarDadosAPI().finally(() => this.scrollToAnchorDiv());
  // }

  // onRouteChanged() {
  //   this.buscarDadosAPI().finally(() => this.scrollToAnchorDiv());
  // }

  @Watch("listaProdutos")
  onListaProdutosChanged() {
    Object.assign(this.produtoInfo, {
      ...this.listaProdutos?.find((p) => p.id === this.produtoInfo?.id),
    });
  }

  openProdutoDialog(item: any) {
    this.produtoInfo = item;

    const prodDlg = this.$refs.prodInfoDlg as ProdutoDetailsDialog;
    prodDlg.show(this.produtoInfo);
  }

  scrollToAnchorDiv() {
    const div = this.$refs.scrlAnchor as any;
    const elementPosition = div.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - 120;
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  }

  // buscarDadosAPI() {
  //   this.isLoading = true;

  //   const url = new URL(window.location.href);
  //   const { page, number, prodSearch, grupoProdutos } = Object.fromEntries(url.searchParams.entries());

  //   const filtros = this.$props.filtros?.map((f: any) => {
  //     return {
  //       field: f.field,
  //       value: f.value,
  //     };
  //   });

  //   let ordenacao = ProdutosService.listaOrdenacaoMap?.[this.$props.ordenacao]?.ord;
  //   if (!ordenacao && !grupoProdutos)
  //     ordenacao = { sortBy: ["produto.descricao_portal"] };

  //   return ProdutosService.findAllCliente({
  //     paginacao: {
  //       page: page ? parseInt(page) : 1,
  //       itemsPerPage: number ? parseInt(number) : 20,
  //       ...ordenacao,
  //     },
  //     searchStr: prodSearch,
  //     filters: [],
  //     grupoProdutos: Number(grupoProdutos),
  //   })
  //     .then((resp: any) => {
  //       this.totalItensServer = +resp.totalrecordcount;
  //       this.listaProdutos = resp.data;
  //     })
  //     .catch(() => {
  //       this.totalItensServer = 0;
  //       this.listaProdutos = [] as Array<any>;
  //     })
  //     .finally(() => {
  //       this.isLoading = false;
  //     });
  // }
}
